<ngx-spinner type = "ball-clip-rotate" size="medium"></ngx-spinner>
